// ─────────────────────────────────────────────────────────────────────────────
// AlertsList.js — the "Recent Alerts" feed, plus the critical-count badge that
// sits in the card header next to it. Items arrive pre-shaped (label / sub /
// time / sev / colour) from mapAlerts in dashboardService.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./AlertsList.module.css";

/** @param {{label: string, sub: string, time: string, color: string}[]} alerts */
export default function AlertsList({ alerts }) {
  return (
    <div className={styles.list}>
      {alerts.map((a, i) => (
        <div key={i} className={styles.item}>
          <span
            className={styles.dot}
            style={{ background: a.color, boxShadow: `0 0 6px ${a.color}` }}
          />
          <div className={styles.text}>
            <div className={styles.label}>{a.label}</div>
            <div className={styles.sub}>{a.sub}</div>
          </div>
          <span className={styles.time}>{a.time}</span>
        </div>
      ))}
    </div>
  );
}

/** Header slot for the alerts card — renders nothing when nothing is critical. */
export function CriticalBadge({ count }) {
  if (!count) return null;
  return <span className={styles.criticalBadge}>{count} Critical</span>;
}
